import { ILink } from "../interfaces/models";

let instance: LinkManager;
export default class LinkManager {
    instanceNum = 1;
    
    constructor() {
        if (!instance) {
            instance = this;
        }

        instance.upInstanceNum;
        return instance;
    }

    profileLink: ILink = {
        text: "Profile",
        href: "",
        icon: "widgets",
        submenu: [{
            text: "Engagement",
            href: "/profile/engagement"
        }, {
            text: "Competencies",
            href: "/profile/competencies"
        }, {
            text: "Achievements",
            href: "/profile/achievements"
        }, {
            text: "Consent",
            href: "/profile/consent"
        }]
    };

    adminLink: ILink = {
        text: "Admin",
        href: "",
        icon: "widgets",
        submenu: [{
            text: "Overview",
            href: "/admin"
        }, {
            text: "Course Reports",
            href: "/admin/reports"
        }, {
            text: "User Profiles",
            href: "/admin/profiles"
        }, {
            text: "Consent Form",
            href: "/admin/consent"
        }, {
            text: "Reported Questions",
            href: "/admin/reported"
        }, {
            text: "Import Questions",
            href: "/admin/import"
        }]
    };

    questionLink: ILink = {
        text: "Questions",
        href: "",
        icon: "question_answer",
        submenu: [{
            text: "Answer",
            href: "/question/answer"
        }, {
            text: "Create",
            href: "/question/create"
        }]
    };
    
    connectLink: ILink = {
        text: "Connections",
        href: "",
        icon: "group",
        submenu: [{
            text: "Connect",
            href: "/view/peers"
        }, {
            text: "Pending",
            href: "/view/peers/pending"
        }, {
            text: "Review",
            href: "/view/peers/review"
        }, {
            text: "Schedule",
            href: "/view/peers/schedule"
        }]
    };

    profilesLink: ILink = {
        text: "Profiles",
        href: "",
        icon: "widgets",
        submenu: [{
            text: "Engagement",
            href: "/profile/engagement"
        }, {
            text: "Competencies",
            href: "/profile/competencies"
        }, {
            text: "Achievements",
            href: "/profile/achievements"
        }]
    };
    
    leaderLink: ILink = {
        text: "Leaders",
        href: "/view/leaderboard",
        icon: "assignment"
    };

    notificationLink: ILink = {
        text: "Notifications",
        href: "/profile/notifications",
        icon: "alarm",
        badge: 0
    };

    getLinks(): ILink[] {
        return [this.adminLink, this.profileLink, this.questionLink, this.notificationLink, this.connectLink,
            this.leaderLink];
    }

    setNotificationBadge(badge: number) {
        this.notificationLink.badge = badge;
    }

    getInstanceNum() {
        return this.instanceNum;
    }

    upInstanceNum() {
        this.instanceNum = this.instanceNum + 1;
    }

    resetLinks(): ILink[] {
        this.profileLink = {
            text: "Profile",
            href: "",
            icon: "widgets",
            submenu: [{
                text: "Engagement",
                href: "/profile/engagement"
            }, {
                text: "Competencies",
                href: "/profile/competencies"
            }, {
                text: "Achievements",
                href: "/profile/achievements"
            }, {
                text: "Consent",
                href: "/profile/consent"
            }]
        };
    
        this.adminLink = {
            text: "Admin",
            href: "",
            icon: "widgets",
            submenu: [{
                text: "Overview",
                href: "/admin"
            }, {
                text: "Course Reports",
                href: "/admin/reports"
            }, {
                text: "User Profiles",
                href: "/admin/profiles"
            }, {
                text: "Consent Form",
                href: "/admin/consent"
            }, {
                text: "Reported Questions",
                href: "/admin/reported"
            }, {
                text: "Import Questions",
                href: "/admin/import"
            }]
        };
    
        this.questionLink = {
            text: "Questions",
            href: "",
            icon: "question_answer",
            submenu: [{
                text: "Answer",
                href: "/question/answer"
            }, {
                text: "Create",
                href: "/question/create"
            }]
        };
    
        this.leaderLink = {
            text: "Leaders",
            href: "/view/leaderboard",
            icon: "assignment"
        };

        this.connectLink = {
            text: "Connections",
            href: "",
            icon: "group",
            submenu: [{
                text: "Connect",
                href: "/view/peers"
            }, {
                text: "Pending",
                href: "/view/peers/pending"
            }, {
                text: "Review",
                href: "/view/peers/review"
            }, {
                text: "Schedule",
                href: "/view/peers/schedule"
            }]
        };
    
        this.notificationLink = {
            text: "Notifications",
            href: "/profile/notifications",
            icon: "alarm",
            badge: 0
        };

        return this.getLinks();
    }

}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader!./src/routes/links.ts